import { shouldCheckPermForLinks } from './tryCheckPermForLinks';
import RecipientExpansionStatus from 'owa-recipient-types/lib/types/RecipientExpansionStatus';
import { orchestrator } from 'satcheljs';
import { expandGroupsAndSmallDLs, tryCheckPermForLinks } from '../actions/publicActions';
import { SharingTipRecipientInfo, lazyGetGroupsAndSmallDLs } from 'owa-sharing-data';
import { expandAndSetRecipientViewState } from '../utils/expandAndSetRecipientViewState';

orchestrator(expandGroupsAndSmallDLs, async actionMessage => {
    if (!shouldCheckPermForLinks(actionMessage.linkIds)) {
        return;
    }

    const getGroupsAndSmallDLs = await lazyGetGroupsAndSmallDLs.import();
    const recipients = getGroupsAndSmallDLs(
        actionMessage.recipientInfos,
        !actionMessage.isCalendar
    );
    const recipientsToExpand: SharingTipRecipientInfo[] = recipients.filter(
        info => info.recipient.expansionStatus === RecipientExpansionStatus.None
    );

    for (let i: number = 0; i < recipientsToExpand.length; i++) {
        await expandAndSetRecipientViewState(recipientsToExpand[i]);
    }

    tryCheckPermForLinks(
        actionMessage.linkIds,
        actionMessage.recipientInfos,
        actionMessage.composeId,
        actionMessage.isCalendar
    );
});
